import { createActionGroup, emptyProps } from '@ngrx/store';

export const badgesPageActions = createActionGroup({
  source: 'Badges Page',
  events: {
    ['Load Earned Badges']: emptyProps(),
  },
});
